import React, { useEffect, useState, useRef } from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { editorTools } from '../../constants/editor.constants'
import { applyToolbarAriaLabels, focusEditorWhenReady } from '../../helpers/editorHelper'

const HtmlEditor = ({
    title,
    description,
    initialHtml,
    onChange,
    fontSize,
    fontFamily,
}) => {
    const [html, setHtml] = useState(initialHtml);
    const contentEditorWrapperRef = useRef();
    const contentEditorRef = useRef();
    const editorInitialized = useRef(false);  // Use ref to avoid re-initialization

    const getEditorInstance = () => {
        const $ = window.jQuery;
        return $(contentEditorRef.current).data('kendoEditor');
    };

    const onContentEditorChange = () => {
        const editor = getEditorInstance();
        if (editor) {
            const newHtml = editor.value();
            setHtml(newHtml);
            if (onChange) {
                onChange(newHtml);
            }
        }
    };

    useEffect(() => {
        if (!editorInitialized.current) {
            const $ = window.jQuery;

            $(contentEditorRef.current).kendoEditor({
                stylesheets: [
                    `/css/editor/font-family-${fontFamily}.css`,
                    `/css/editor/font-size-${fontSize}.css`,
                ],
                tools: editorTools,
                change: onContentEditorChange,
            });

            const editor = getEditorInstance();
            if (editor) {
                editor.value(html);
                focusEditorWhenReady(editor);
                applyToolbarAriaLabels(editor);
            }

            editorInitialized.current = true;  // Mark editor as initialized
            contentEditorWrapperRef.current.style.display = 'block';
        }
    }, [fontSize, fontFamily]);  // Run only when font size or family changes

    useEffect(() => {
        const editor = getEditorInstance();
        if (editor) {
            editor.value(html);
        }
    }, [html]);

    return (
        <div>
            {title && <Typography variant="h6">{title}</Typography>}
            {description && <Typography gutterBottom>{description}</Typography>}
            <div style={{ height: 400 }}>
                <div ref={contentEditorWrapperRef} style={{ display: 'none' }}>
                    <textarea style={{ height: 380 }} ref={contentEditorRef} />
                </div>
            </div>
        </div>
    );
};

HtmlEditor.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    initialHtml: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fontSize: PropTypes.string,
    fontFamily: PropTypes.string,
};

export default HtmlEditor;
